import axios from 'axios';
import { API_URL } from 'config.js';
import { store } from 'store.js';
import { aggiornaCategorie, aggiornaFornitori, aggiornaMetodiPagamento, caricamento } from 'features/65/notaSpeseSlice';

const API_STEP_1 = `${API_URL}/65/get_fornitori/`;
const API_STEP_2 = `${API_URL}/65/set_notaspese/`;

export async function step1() {
  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    store.dispatch(caricamento(true));

    const res = await axios.post(API_STEP_1, { utente, pin });
    const { successo = false, data = [], categorie = [], pagamenti = [] } = res.data;

    if (!successo) throw new Error(JSON.stringify(res));

    store.dispatch(aggiornaCategorie(categorie));
    store.dispatch(aggiornaFornitori(data));
    store.dispatch(aggiornaMetodiPagamento(pagamenti));
  } catch (e) {
    // eslint-disable-next-line no-alert
    alert('Unable to load data');
    console.log(e);
  } finally {
    store.dispatch(caricamento(false));
  }
}

// converte le immagini in b64
export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export async function step2(form, imm, reset) {
  store.dispatch(caricamento(true));

  const {
    auth: {
      currentUser: { pin, utente },
    },
  } = store.getState();

  try {
    // converto l'immagine
    const immagine = await convertBase64(imm);

    const res = await axios.post(API_STEP_2, { utente, pin, ...form, immagine });
    const { successo = false } = res.data;

    if (!successo) throw new Error(JSON.stringify(res));

    alert('Nota spesa inserita con successo');
  } catch (error) {
    // eslint-disable-next-line no-alert
    alert('Impossibile inserire la nota');
    alert(JSON.stringify(error));
    console.log(error);
  } finally {
    reset();
    store.dispatch(caricamento(false));
  }
}
